module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp12_9016.c9c11727.png";